export default __webpack_public_path__ + "static/media/wordprez.f7961c09.svg";